import { WebElement, ISize, IRectangle, Locator, WebElementPromise } from 'selenium-webdriver';
import { DialogWebElementBase } from './DialogWebElementBase';

/**
 * The component WebElement for [oj-c-dialog](../../jsdocs/oj-c.Dialog.html).
 * Do not instantiate this class directly, instead, use
 * [findDialog](../functions/findDialog.html).
 */
export class DialogWebElement extends DialogWebElementBase {
  public async isDisplayed(): Promise<boolean> {
    const content = await this.getContent();
    if (!content) return false;
    return content.isDisplayed();
  }

  public getSize(): Promise<ISize> {
    return this.getContent()
      .then((content) => content.getRect())
      .then((rect) => Promise.resolve({ width: rect.width, height: rect.height }));
  }

  public getRect(): Promise<IRectangle> {
    return this.getContent().then((content) => content.getRect());
  }

  public getText(): Promise<string> {
    return this.getContent().then((content) => content.getText());
  }

  public findElement(locator: Locator): WebElementPromise {
    const p = this.whenReady()
      .then(() => this.getContent())
      .then((content) => content.findElement(locator));
    return new WebElementPromise(this.getDriver(), p);
  }

  public async findElements(locator: Locator): Promise<WebElement[]> {
    const content = await this.getContent();
    return content.findElements(locator);
  }

  private async getContent(): Promise<WebElement> {
    await this.whenBusyContextReady();
    const content = await this.getDriver().executeScript<WebElement>((el: any) => {
      const LAYER_CONTENT = Symbol.for('__oj_c_layer_content');
      return el[LAYER_CONTENT];
    }, this);
    return content;
  }

  /**
   * Dismisses the dialog.
   */
  public doClose(): Promise<void> {
    return this.setProperty('opened', false);
  }
}
